import { createElement } from 'react';
import { render } from 'react-dom';
import { fetchShoppingCartPageTranslations } from '../react/services/TranslationService';

export default class ShoppingCart {
    constructor() {
        this.container = document.querySelector('.js-shopping-cart');

        if (this.container) {
            this.start();
        }
    }

    start() {
        const cartCopy = this.container.getAttribute('data-cart-copy'),
            user = this.container.getAttribute('data-user');
        Promise.all([
            import('../react/pages/shopping-cart.jsx'),
            fetchShoppingCartPageTranslations()
        ])
            .then(([ShoppingCart, translations]) => {
                render(createElement(ShoppingCart.default, { cartCopy, user, translations }), this.container);
            })
            .catch(error => {
                console.log(error);
            });
    }
}